import * as React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import type { StockoutSignal } from '@/lib/api-client'

/** Count of stockout-signature events per month. */
export function StockoutMonthChart({ stockouts }: { stockouts: StockoutSignal[] }) {
  const data = React.useMemo(() => {
    const m = new Map<string, number>()
    for (const s of stockouts) m.set(s.month, (m.get(s.month) ?? 0) + 1)
    return [...m.entries()]
      .map(([month, events]) => ({ month, events }))
      .sort((a, b) => a.month.localeCompare(b.month))
  }, [stockouts])

  if (!data.length) {
    return (
      <div className="rounded-xl border border-border bg-card p-8 text-center text-sm text-text-muted">
        No stockout signals in this window.
      </div>
    )
  }

  return (
    <div className="rounded-xl border border-border bg-card p-4">
      <h3 className="text-sm font-semibold text-text-dark mb-3">Stockout events by month</h3>
      <div className="h-[240px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 8, right: 12, bottom: 4, left: -12 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" vertical={false} />
            <XAxis dataKey="month" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
            <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} formatter={(v: any) => [`${v} events`, 'Stockouts']} />
            <Bar dataKey="events" radius={[6, 6, 0, 0]} fill="#f59e0b" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
